import React, { useState } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from "axios";

function DeleteConfirmationModal({AutoID, Name, close, getNewOrgsUpdate}) {
  const [modal, setModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleDelete = async () => {
    try {
      await axios.delete(`api/orgs/${AutoID}`);
      alert('Organization deleted successfully');
      setModal(false);
      getNewOrgsUpdate();
      close();
    } catch (error) {
      console.error('There was an error deleting the organization!', error);
      setErrorMessage('Failed to delete the organization'); 
    }
  };

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="danger" onClick={toggle}>
        Delete
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Confirm Deletion
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete {Name}? This action cannot be undone.
          Please confirm if you wish to proceed with the deletion.
          {errorMessage && <p style={{color: 'red'}}>{errorMessage}</p>} {/* Display error message */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleDelete}>
            Confirm
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

// Define PropTypes for the component
DeleteConfirmationModal.propTypes = {
  AutoID: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
};

export default DeleteConfirmationModal;
